/**
 * Persistent session expiry helpers.
 * Always store numeric epoch ms — ISO strings break parseInt() and expire incorrectly.
 */

export const SESSION_EXPIRY_KEY = 'acctoo_session_expiry';
export const SESSION_USER_KEY = 'acctoo_user';
export const DEFAULT_SESSION_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

/** @returns {number|null} epoch ms or null if missing/invalid */
export const parseSessionExpiry = (raw = null) => {
  const value = raw ?? (typeof localStorage !== 'undefined' ? localStorage.getItem(SESSION_EXPIRY_KEY) : null);
  if (value == null || value === '') return null;

  if (typeof value === 'number' && Number.isFinite(value)) return value;

  const asNumber = Number(value);
  if (Number.isFinite(asNumber) && asNumber > 1e11) return asNumber; // already ms

  // Legacy ISO / date strings
  const fromDate = Date.parse(String(value));
  if (Number.isFinite(fromDate)) return fromDate;

  const parsedInt = parseInt(String(value), 10);
  if (Number.isFinite(parsedInt) && parsedInt > 1e11) return parsedInt;

  return null;
};

export const isSessionExpiryValid = (raw = null) => {
  const expiry = parseSessionExpiry(raw);
  return expiry != null && Date.now() < expiry;
};

export const writeSessionExpiry = (durationMs = DEFAULT_SESSION_MS) => {
  const expiry = Date.now() + durationMs;
  localStorage.setItem(SESSION_EXPIRY_KEY, String(expiry));
  return expiry;
};

export const clearSessionStorageKeys = () => {
  try {
    localStorage.removeItem(SESSION_USER_KEY);
    localStorage.removeItem(SESSION_EXPIRY_KEY);
    localStorage.removeItem('user_mpin');
    localStorage.removeItem('last_login');
    localStorage.removeItem('session_expiry');
    localStorage.removeItem('acctoo_auth_token');
    localStorage.removeItem('acctoo_user_id');
    localStorage.removeItem('acctoo_mpin_data');

    // Clear MPIN lockouts and client rate-limit keys
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (
        key.startsWith('mpin_lockout_') ||
        key.startsWith('rate_limit_') ||
        key.startsWith('acctoo_wizard_seen_')
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
};
